import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './components/Home';
import Feedback from './components/Feedback';
import GenerateQRPage from './components/admin/GenerateQR';
import ViewClaims from './components/admin/ViewClaims';
import UploadCertificate from './components/admin/UploadCertificate';
import { Bounce, ToastContainer } from 'react-toastify';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/feedback" element={<Feedback />} />
        <Route path="/generate" element={<GenerateQRPage />} />
        <Route path="/view-claims" element={<ViewClaims />} />
        <Route path="/uploadcert" element={<UploadCertificate />} />
      </Routes>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
    </Router>
  );
};

export default App;
